export default "__VITE_ASSET__DnAy6tbW__"